module.exports = __webpack_public_path__ + "img/201.37feeba3.jpg";